import { render, staticRenderFns } from "./TexPassportList.vue?vue&type=template&id=b3baa078&scoped=true&"
import script from "./TexPassportList.vue?vue&type=script&lang=js&"
export * from "./TexPassportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3baa078",
  null
  
)

export default component.exports